import React from "react";
import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import SelectInput from "features/shared/components/selectInput/SelectInput";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styles from "features/shared/components/dataGrid/datagridheader.module.scss";
import Card from "features/shared/components/card/Card";

type Props = {
  years: number[];
  selectedYear: number;
  setSelectedYear: React.Dispatch<React.SetStateAction<number>>;
  onDownloadExcelClick: () => void;
  setShowFilterModal?: React.Dispatch<React.SetStateAction<boolean>>;
  filterActive?: boolean;
  count?: number;
  countLabel?: string;
};

const MeasuredDataHistoryHeader = ({
  years,
  selectedYear,
  setSelectedYear,
  setShowFilterModal,
  count,
  filterActive,
  onDownloadExcelClick,
  countLabel
}: Props) => {

  // translations
  const tComponents = useTranslation("shared\\components").t;

  // sub-renders
  const renderYearSelect = () => {
    return (
      <SelectInput
        name={"contractsDuratioYearSelect"}
        options={years.map((x) => ({
          value: x.toString(),
          name: x.toString(),
        }))}
        value={selectedYear}
        onChange={(e) => setSelectedYear(Number(e.target.value))}
        className="mb-0 w-100"
      />
    );
  };

  const renderFilterButton = () => { 
    if (setShowFilterModal) {
      return (
        <div className="col col-sm-auto pl-1">
          <button
            onClick={() => setShowFilterModal(true)}
            className={`btn btn-block btn-sm btn-secondary ${
              filterActive ? ` ${"styles.filterBtn"}` : ""
            }`}
          >
            {tComponents("dataGridHeader.filtering")}
            {filterActive && (
              <span className={styles.activeFilterIndicator}>
                <FontAwesomeIcon icon="check" size="xs" />
              </span>
            )}
          </button>
        </div>
      );
    }
  }

  const renderCountInfo = () => { 
    if (count !== undefined && countLabel !== undefined) {
      return (
        <div className="col-auto px-2 pr-sm-3 px-sm-0">
          <div className="d-flex align-items-center">
            <span className="mr-2 text-muted">
              {countLabel}
              :
            </span>
            {count}
          </div>
        </div>
      );
    }
  }

  // render
  return (
    <Card className={styles.headerBox}>
      <div className="row no-gutters align-items-center mx-n2 mx-sm-0">
        <div className="col col-sm-auto pr-sm-3 px-2 px-sm-0">
          <div className="d-flex align-items-center">
            <span className="mr-2 text-muted">
              {tComponents("measuredDataHistoryHeader.year")}:
            </span>
            {renderYearSelect()}
          </div>
        </div>
        {renderCountInfo()}
        <div className="col-12 col-sm-auto ml-sm-auto mt-3 mt-sm-0 px-2 px-sm-0">
          <div className="row no-gutters">
            <div className="col col-sm-auto pr-1">
              <button
                onClick={onDownloadExcelClick}
                className="btn btn-block btn-sm btn-secondary"
              >
                <span className="mr-2">
                  <FontAwesomeIcon icon="file-excel" />
                </span>
                <span className="mr-1">
                  {tComponents("measuredDataHistoryHeader.downloadExcel")}
                </span>
              </button>
            </div>
            {renderFilterButton()}
          </div>
        </div>
      </div>
    </Card>
  );
};

export default MeasuredDataHistoryHeader;
